import { css, keyframes } from 'styled-components';
import { Media } from '../Mixins.style';

import fadeIn from 'react-animations/lib/fade-in';
import fadeOut from 'react-animations/lib/fade-out';

import zoomIn from 'react-animations/lib/zoom-in';
import bounceOut from 'react-animations/lib/bounce-out';

const fadeInAnimation = keyframes`${fadeIn}`;
const fadeOutAnimation = keyframes`${fadeOut}`;

const zoomInAnimation = keyframes`${zoomIn}`;
const bounceOutAnimation = keyframes`${bounceOut}`;

export const Wrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 105;
`;

export const Holder = css`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 20px;
  overflow: auto;
  background: ${props => props.theme.background};
  opacity: 0;

  ${Media.lg`
    padding: 20px;
  `};

  ${Media.sm`
    padding: 10px;
  `};

  &[data-open] {
    opacity: 1;
    animation: ${fadeInAnimation} 0.2s;
  }

  &[data-close] {
    animation: ${fadeOutAnimation} 0.2s;
  }

  &[data-visible] {
  }

  &::-webkit-scrollbar {
    width: 9px;
    height: 9px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.thumb};
    border-radius: 9px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.track};
  }
`;

export const Panel = css`
  position: relative;
  display: block;
  margin: auto;
  border-radius: 4px;
  background: ${props => props.theme.background};
  box-shadow: ${props => props.theme.shadow};
  opacity: 1;
  overflow: hidden;

  &[data-open] {
    animation: ${zoomInAnimation} 0.2s;
  }

  &[data-close] {
    animation: ${bounceOutAnimation} 0.2s;
  }
`;

export const Close = css`
  position: absolute;
  top: 9px;
  right: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 25px;
  height: 25px;
  color: ${props => props.theme.color};
  transition: 0.2s color;
  cursor: pointer;
  z-index: 101;

  &:hover {
    color: ${props => props.theme.colorOnHover};
  }
`;

export const CloseIcon = css`
  display: block;
  font-size: 18px;
  user-select: none;

  ${Media.lg`
    font-size: 16px;
  `}
`;

export const Content = css`
  display: block;
  width: 100%;
`;
